module.exports = __webpack_public_path__ + "img/up_arrow_icon.d71d8d79.svg";